import { Container, Header, SpaceBetween, Button, Tabs } from "@amzn/awsui-components-console";
import { useSendAskMessage, useSendMessage } from "@amzn/awt-module-react-utils";
import { messageTypes, RequestType, useAppContext, websiteId } from "@amzn/region-flex-interface-module-website-common";
import { useState } from "react";
import { MigrationStepLoader } from "./MigrationStepLoader";

export const SampleComponent = () => {
  const sendAskMessage = useSendAskMessage();
  const sendMessage = useSendMessage();

  const { currentUser, currentUserOverride } = useAppContext();
  const [alertId, setAlertId] = useState<string | undefined>();

  return (
    <SpaceBetween size="l">
      <Container header={<Header>User Information</Header>}>
        <SpaceBetween size="m">
          <div>Current Logged In User: {currentUser.alias}</div>
          <div>Current View-As User: {currentUserOverride || currentUser.alias}</div>
        </SpaceBetween>
      </Container>

      <Container header={<Header>Alert Management</Header>}>
        <SpaceBetween direction="horizontal" size="s">
          <Button
            onClick={async () => {
              const reply = await sendAskMessage(
                messageTypes.addFlashbar.create({
                  to: websiteId,
                  payload: {
                    type: "in-progress",
                    operation: RequestType.UPDATE,
                    relevantPages: [window.location.pathname],
                    resourceTypeName: `a test alert`,
                  },
                })
              );
              setAlertId(reply.payload);
            }}
          >
            Create Test Alert
          </Button>
          {alertId ? (
            <Button
              onClick={() =>
                sendMessage(
                  messageTypes.updateFlashbar.create({
                    to: websiteId,
                    payload: {
                      flashbarId: alertId,
                      type: "success",
                    },
                  })
                )
              }
            >
              Update Test Alert
            </Button>
          ) : null}
        </SpaceBetween>
      </Container>
      <Container>
        <Tabs
          tabs={[
            {
              label: "Workflow Node With Registered Module",
              id: "registered",
              content: (
                <MigrationStepLoader
                  {...{
                    migrationPlanId: "test-plan",
                    workflowId: "test-workflow",
                    moduleId: "migration-step",
                    serviceId: "test-service",
                    version: "1.0.0",
                    rfpVersion: "2.0.0",
                  }}
                />
              ),
            },
            {
              label: "Workflow Node With No Module",
              id: "not-registered",
              content: (
                <MigrationStepLoader
                  {...{
                    migrationPlanId: "test-plan",
                    workflowId: "test-workflow",
                    moduleId: "no-migration-step-exists",
                    serviceId: "test-service",
                    version: "1.0.0",
                    rfpVersion: "2.0.0",
                  }}
                />
              ),
            },
          ]}
        />
      </Container>
    </SpaceBetween>
  );
};
